import React from 'react';

function Editais() {
  return (
    <div>
      <h1>Editais</h1>
    </div>
  );
}

export default Editais;
